import React, { useMemo } from "react";
import Heart from "mdi-material-ui/Heart";
import MessageReplyTextOutline from "mdi-material-ui/MessageReplyTextOutline";

const CommentActions = ({ auth, comment, handleCommentVote, setReplyCommentModal, isReply, userCanReply }) => {
  const hasSelfVote = comment?.votes?.find((user) => user.user_id === auth.user.user_id);
  const voteCount = comment?.votes?.length || 0;

  const canReply = () => {
    //isReply === false || userCanReply === true
    if (isReply === false && userCanReply === true) return true;
    if (userCanReply === true) return true;
    return false;
  };

  const MemoCommentActions = useMemo(
    () => (
      <div className="comment-actions">
        <button
          type="button"
          className={`comment-action comment-action--like ${hasSelfVote ? "is-active" : ""}`}
          aria-label={hasSelfVote ? "Remover gosto" : "Gostar"}
          title={hasSelfVote ? "Remover gosto" : "Gostar"}
          onClick={() => handleCommentVote(hasSelfVote ? "remove" : "add", comment._id)}
        >
          <Heart />
          {voteCount > 0 && <span className="comment-action__count">{voteCount}</span>}
        </button>
        {canReply() === true && (
          <button type="button" className="comment-action comment-action--reply" onClick={() => setReplyCommentModal({ visible: true })}>
            <MessageReplyTextOutline />
            Responder
          </button>
        )}
      </div>
    ),
    [hasSelfVote, voteCount, comment, handleCommentVote, setReplyCommentModal, isReply, userCanReply]
  );

  return MemoCommentActions;
};

export default CommentActions;
